const utils = require("frontend-controller/lib/utils");
module.exports = {
    extends: [
        '/',
        'templates',
        'core',
        'table',
        'table',
    ],

    config: {
        buttonContext: 'statusFlags',
        showHead: true,
        showIDs: true,
        showTDVerticalTop: true,
        isSortable: true,
        preventSortOfField: {
            entityReasonSeverityType: true
        },
        rowActionsInline: true,
        rowActionsProperties: {
            // colWidth: '105px',
            colWidth: '75px',
        },
        rowActions: {
            // edit: true,
            // customs: [
            //     // {
            //     //     buttonType: 'showLocation',
            //     // },
            //     // {
            //     //     buttonType: 'delete',
            //     //     neutral: true,
            //     // }
            // ]
        },
        hindersCustomerOrderOnly: false,
        'heartbeatRefreshOn': {
            'resourceChanged.bo_status': true,
        },
    },

    model: {
        parentEntityForStatus: null, // TODO: DOCS
        resourceFilters: {
            order: [{
                fieldCode: 'severity',
                direction: 'desc'
            },{
                fieldCode: 'entity',
                direction: 'asc'
            }]
        }
    },

    methods: {
        // onPrepareDone(){
        //     this.config.customHeadActionsFormMapping = {
        //         buttons: [
        //             { buttonType: 'showInsert', context: this.config.buttonContext, positive: true }
        //         ]
        //     }
        // },

        sanitizeResourceFilters: function(storage, resourceFilters, actionKey, areBaseTableResourceFilters){
            if(areBaseTableResourceFilters){
                if(!this.model.parentEntityForStatus){
                    this.model.parentEntityForStatus = this.getResourceRegisterContent('parentEntityForStatus') || false
                }
                if(this.model.parentEntityForStatus){
                    utils.refMerge(resourceFilters, {
                        baseFilters:    this.model.parentEntityForStatus.baseFilters || {},
                    })
                }
            }
        },

        // stores loadedStatusIDs
        storeLoadedStatusIDs(){
            this.model.loadedStatusIDs = {}
            for(const e in this.model.entityList){
                const statusID = ((this.model.entityList[e] || {}).attributes || {}).statusID
                if(statusID){
                    this.model.loadedStatusIDs[statusID] = true
                }
            }
        },

        prepareForSubmit(){
            // TODO: DOCS
            this.config.heartbeatRefreshOn = {}
        },

        showEdit(entityID, entityData){
            // override default behaviour
        },

        onHeartbeat(message, heartbeatPrewarmedResourceHashes){
            const refreshers = this.config.heartbeatRefreshOn || {}
            const key = message.heartbeatKey

            if(refreshers[key] && (
                (
                    key !== 'resourceChanged.bo_status'
                ) ||
                (key === 'resourceChanged.bo_status' && this.isAtLeastOneStatusIDLoaded(message.data.statusIDs))
            )){
                this.refreshData(true, { refreshResourcesViaHeartbeatKey: key, heartbeatPrewarmedResourceHashes })
            }
        },
    }
}